import SelectOptionAsync from 'Component/Common/Select/SelectOptionAsync';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFormData } from 'Services/Features/Product/productSlice';
import { getCategoryProduct } from 'Services/Features/CategoryProduct/Utils/categoryProductUtils';

const SelectCategoryProduct = () => {
    const dispatch = useDispatch();
    const currentCategory = useSelector(state => state.product.currentProduct);
    const filter = useSelector(state => state.categoryProduct.filters);
    const [selectedValue, setSelectedValue] = useState(null);

    const handleChangeCategory = (selectedOption) => {
        console.log(selectedOption, 'selectedOption');
        setSelectedValue(selectedOption === null ? '' : selectedOption);
        dispatch(setFormData({ category_id: selectedOption === null ? '' : selectedOption.value }));
    };
    


    useEffect(() => {
        const selectedCategory = currentCategory.category && currentCategory.category.id
            ? [{
                value: currentCategory.category.id,
                label: currentCategory.category.name,
            }]
            : selectedValue;
        setSelectedValue(selectedCategory);
    }, [currentCategory.category]);

    const promiseOptionCategory = (inputValue, callback) => {
        dispatch(getCategoryProduct({
            ...filter,
            'filter[name]': inputValue,
            'sort': 'name',
            'page': 1,
        }))
            .then((response) => {
                const options = response.payload.data.map(item => ({
                    value: item.id,
                    label: item.name,
                }));
                callback(options);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
                callback([]);
            });
    };

    
    return (
        <SelectOptionAsync
            promiseOptions={promiseOptionCategory}
            handleChange={(selectedOption) => handleChangeCategory(selectedOption)}
            selectedValue={selectedValue}
            placeholder="Pilih Kategori"
            isMulti={false}
        />
    )
}

export default SelectCategoryProduct;
